//# sourceMappingURL=my-selector.interface.js.map


//////////////////
// WEBPACK FOOTER
// /revet-web/node_modules/mydatepicker/dist/interfaces/my-selector.interface.js
// module id = ../../../../mydatepicker/dist/interfaces/my-selector.interface.js
// module chunks = vendor